interface HttpResponse extends Response {
    parsedBody?: Record<string, unknown>;
}

function handleResponse(response: HttpResponse): HttpResponse {
    if (!response.ok) {
        const message = {
            statusText: response.statusText,
            statusCode: response.status
        };
        throw message;
    }
    return response;
}

export default handleResponse;
